import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { CompanyJobsDirectory } from '@/features/company-jobs-directory'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  sortBy: z.string().optional().catch(undefined),
  sortDir: z.enum(['asc', 'desc']).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  dept: z.string().optional().catch(undefined),
  postedAfter: z.string().optional().catch(undefined),
  postedBefore: z.string().optional().catch(undefined),
  expMin: z.number().optional().catch(undefined),
  expMax: z.number().optional().catch(undefined),
  // Tag names travel in the URL (shareable, human-readable); ids are resolved
  // client-side from the vocabulary. Matches /companies.
  tags: z.array(z.string()).optional().catch([]),
  tagsMode: z.enum(['any', 'all']).optional().catch('any'),
  // Server-persisted resume match. The id is the whole contract: the derived
  // query strings and their cached embeddings live on the row, so refresh and
  // share replay identically. A malformed id degrades to browse mode rather
  // than firing a doomed request.
  resumeSearch: z.string().uuid().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/company-jobs/directory')({
  validateSearch: searchSchema,
  component: CompanyJobsDirectory,
})
